import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import Navbar from './components/main/Navbar.jsx';
import Landing from './components/main/Landing.jsx';
import Explore from './components/main/Explore.jsx';
import About from './components/main/About.jsx';
// import Footer from './components/main/Footer.jsx';
import SignIn from './components/main/SignIn.jsx';
import SignUp from './components/main/SignUp.jsx';
import Trips from './components/main/Trips.jsx';
import ProtectedRoute from 'signup/ProtectedRoute.jsx';
import CityPage from 'components/city/CityPage.jsx';
import { NavigationProvider } from 'context/NavigationContext.jsx';

const App = () => {
  return (
    <NavigationProvider>
      <BrowserRouter>
        <Box>
          <Navbar />
          <CssBaseline />
          <Routes>
            <Route exact path='/' element={<Landing homePage={true}></Landing>}></Route>
            <Route exact path='/explore' element={<Explore></Explore>}></Route>
            <Route path='/explore/:id' element={<CityPage></CityPage>} />
            <Route exact path='/about' element={<About></About>}></Route>
            <Route exact path='/signin' element={<SignIn></SignIn>}></Route>
            <Route exact path='/signup' element={<SignUp></SignUp>}></Route>
            {/* <Route exact path='/profile' element={<Profile></Profile>}></Route> */}
            <Route exact path="/profile"
              element={
                <ProtectedRoute>
                  <Trips />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Box>
      </BrowserRouter>
    </NavigationProvider>
  );
};

export default App;
